import React from 'react'

function TenderTextJetnozzle() {
  return (
    <embed src="\pdfs\EAT1.2.3.3_DW-N2_Jet_nozzle_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextJetnozzle